<body>
    <section class="section_one" *ngIf="show">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="ibox">
                        <div class="ibox-title report_flexweb">
                            <div>
                                <h5 class="dashboard"> Surveillances</h5>
                            </div>
                            <div class="icon_flex">
                                <!-- <div>
                                    <button class="create" (click)="open()">Add New </button>
                                </div> -->
                            </div>
                        </div>
                        <div class="dashboardcard_grid">
                            <div class="card card-height" *ngFor="let emp of employes let i=index" (click)="page(emp)">
                                <div class="p">
                                    <figure>
                                        <!-- <img src="../../assets/image/photo12.svg" class="photo"> -->
                                        <img [src]="emp.imageUrl " class="photo" alt="Employee Photo">
                                    </figure>
                                </div>
                                <div class="text">
                                    <h1 class="text-name">{{emp.userName}}</h1>
                                    <h5 class="empname">{{emp.payRollId}}</h5>
                                    <!-- <h5 class="empname">{{emp.empId}}</h5>
                                    <h5 class="empname">{{emp.designation}}</h5>
                                    <h5 class="empname">{{emp.camerasAlloted}}</h5> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- desktop table view close-->
                </div>
            </div>
        </div>
    </section>
    <section *ngIf="!show">
        <div class="container">
            <div class="row">
                <div class="col-md-9">
                    <div class="ibox">
                        <div>
                            <div class="searchemp_flex">
                                <div class="searchemp_left">
                                    <div *ngIf="search">
                                        <div>
                                            <div>
                                                <button class="backbutton" (click)="Dashboard()"><span><img
                                                            src="../../assets/image/outline-arrow-back.svg"></span>Back</button>
                                            </div>

                                        </div>
                                        <div class="card" *ngFor="let emp of searchemployesslist">
                                            <div class="p">
                                                <figure>
                                                    <img [src]="emp.imageUrl" class="photo">
                                                </figure>
                                            </div>
                                            <div class="text">
                                                <h1 class="text-name">{{ emp.empName }}</h1>
                                                <hr>
                                                <p class="text-payroll">PAYROLL ID: {{ emp.payrollId }}
                                                </p>
                                                <hr>
                                                <p class="text-designation">DESIGNATION: {{
                                                    emp.designation }}</p>
                                                <hr>
                                                <p class="text-date">MOBILE NO: {{ emp.mobileNo }}</p>
                                            </div>
                                            <ng-template #noData>
                                                <p>No employees found.</p>
                                            </ng-template>
                                        </div>

                                        <div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cameraContainer">

                                    <div class="searchemp_right">
                                        <div class="ibox-title report_flexweb">
                                            <div>
                                                <h5 class="Existingcameras">
                                                    <h5 class="Existingcameras">
                                                        Assigned Campus List : {{ totalCampusCount }} (Filtered: {{
                                                        filteredCampusCount }})
                                                    </h5>
                                                </h5>
                                            </div>
                                            <div class="icon_flex">
                                                <div>
                                                </div>
                                            </div>

                                        </div>

                                        <ag-grid-angular class="ag-theme-alpine" style="width: 100%; height: 500px;"
                                            [rowData]="rowData" [columnDefs]="columnDefs"
                                            [defaultColDef]="defaultColDef" [autoGroupColumnDef]="autoGroupColumnDef"
                                            [groupDefaultExpanded]="1" [animateRows]="true"
                                            (gridReady)="onGridReady($event)" rowSelection="single"
                                            (filterChanged)="onFilterChanged()">
                                        </ag-grid-angular>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <aside *ngIf="!show" class="aside">
                <div class="container">
                    <div class="heading">
                        <p class="addcamera font_size_20">Add Campus</p>
                    </div>

                    <div class="scrollable-content">
                        <div>
                            <p class="campus-name">City Name</p>
                            <mat-select class="form_select">
                                <input type="text" class="matInput" matInput [formControl]="cityControl"
                                    [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete"></mat-autocomplete>
                                <mat-option *ngFor="let item of filteredCity | async" [value]="item"
                                    (click)="onCampusChange(item)">
                                    {{ item.cityName }}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div>
                            <p class="campus-name">Campus Name</p>
                            <mat-select class="form_select">
                                <input type="text" class="matInput" matInput [formControl]="campusControl"
                                    [matAutocomplete]="auto2">
                                <mat-autocomplete #auto2="matAutocomplete"></mat-autocomplete>
                                <mat-option *ngFor="let item of filteredCampuses | async" [value]="item"
                                    (click)="onbuildingChange(item)">
                                    {{ item.campusName }}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div *ngIf="buildingData">
                            <p class="campus-name">Building Name</p>
                            <ul class="building-list">
                                <li *ngFor="let building of buildingData" (click)="onbuilding(building)">
                                    {{ building.buildingName }}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="button-container">
                        <button type="button" class="applybtn" (click)="Addcampus()">Add campus</button>
                    </div>
                </div>
            </aside>
        </div>


    </section>

</body>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>